import type { TrainableUnitType } from '../types/train';

/** SF-141: extracted out of `Training.tsx` — `react-refresh/only-export-components` blocks a
 *  non-component runtime export from a component file (CLAUDE.md precedent: `constants/navPillars.ts`,
 *  `constants/sidebarNav.ts`). Trainable units in order (matches optimize algorithm priority). */
export const TRAINABLE_UNITS: Array<{
  type: TrainableUnitType;
  key: 'offenseSpecialist' | 'defenseSpecialist' | 'elite' | null;
}> = [
  { type: 'OFFENSE_SPECIALIST', key: 'offenseSpecialist' },
  { type: 'DEFENSE_SPECIALIST', key: 'defenseSpecialist' },
  { type: 'ELITE', key: 'elite' },
  { type: 'THIEF', key: null },
];
